import {ACCOUNT_DEFINITION, EXERCISE_RESERVATION, MY_ACCOUNT, SEAT_SALE} from "../../Routing/routes";
import { ReservationConfig } from "../../models/ReservationConfig";

export default (config: ReservationConfig) => [
  { name: "Kup bilet", path: EXERCISE_RESERVATION, loginRequired: false },
  // ...(config.reservationSeat ? [{ name: "Kup miejsce", path: SEAT_SALE, loginRequired: false }] : []),
  { name: "Kup miejsce", path: SEAT_SALE, loginRequired: false },
  { name: "Moje konto", path: MY_ACCOUNT, loginRequired: true },
  { name: "Doładuj konto", path: ACCOUNT_DEFINITION, loginRequired: true },
];
